import { render, staticRenderFns } from "./DocumentDisplay.vue?vue&type=template&id=fb8b5758&scoped=true"
import script from "./DocumentDisplay.vue?vue&type=script&lang=js"
export * from "./DocumentDisplay.vue?vue&type=script&lang=js"
import style0 from "./DocumentDisplay.vue?vue&type=style&index=0&id=fb8b5758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8b5758",
  null
  
)

export default component.exports